import { Injectable } from '@angular/core';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import { CreateOrUpdateCampaignReqBody } from '../models/campaign/CampaignCreateOrUpdateRequest';
import { PartnerCampaignGridRequest } from '../models/campaign/anyoPartnerCampaignGridRequest';
import { PartnerCampaignGridResponse } from '../models/campaign/anyoPartnerCampaignGridResponse';
import { AnyoPartnerCampaign } from '../models/campaign/AnyoPartnerCampaign';
import { CampaignExpertPayoutResult } from '../models/campaign/CampaignPayoutResult';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  constructor(private api: NetworkUtilsService) {}

  public addOrUpdateCampaign(req: CreateOrUpdateCampaignReqBody) {
    return this.api.post<CampaignExpertPayoutResult[] | Record<string, unknown>>(
      URL_DICT.adminCampaignUpsertUrl,
      req,
    );
  }

  public getCampaign(campaignId: string) {
    return this.api.post<AnyoPartnerCampaign>(URL_DICT.adminCampaignGetUrl + campaignId);
  }

  public getCampaignsGrid(gridReq: PartnerCampaignGridRequest) {
    return this.api.post<PartnerCampaignGridResponse>(URL_DICT.adminCampaignGridUrl, gridReq);
  }
}
